import { render, staticRenderFns } from "./dash.vue?vue&type=template&id=0c564d8e&"
import script from "./dash.vue?vue&type=script&lang=js&"
export * from "./dash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports